import React, { useState } from "react";
import "./ColorPicker.scss";

const { Saturation, Hue, EditableInput } = require("react-color/lib/components/common");
const tiny = require("tinycolor2");

const basePointerStyles = {
  width: "17px",
  height: "17px",
  marginTop: "-1px",
  borderRadius: "50%", 
  border: "2px solid white",
  boxShadow: "0px 0px 2px black"
}

const inputStyles = {
  input: {
    border: '1px solid #777777B3',
    borderRadius: '6px',
    height: '36px',
    color: '#333'
  }
};

export interface ColorPickerProps {
  onColorChange: (val: string) => void;
}

export default function ColorPicker({ onColorChange }: ColorPickerProps) {
  const [hsl, setHsl] = useState({ h: 0, s: 0, l: 1 });
  const [hsv, setHsv] = useState({ h: 0, s: 0, v: 1 });
  const [hueAsHex, setHueAsHex] = useState("ff0000");
  const [value, setValue] = useState("ffffff");

  function onSaturationChange(color: any) {
    const tc = tiny(color);
    const hex = tc.toHex();

    if (color.s === 0 || hex === '000000') {
      let hsl = tc.toHsl();
      hsl.h = color.h;
      let hsv = tc.toHsv();
      hsv.h = color.h;
      if (hex === '000000') {
          hsl.s = color.s;
          hsv.s = color.s;
      }
      setHsl(hsl);
      setHsv(hsv);
      setValue(hex);
    } else {
      setHsl(tc.toHsl());
      setHsv(tc.toHsv());
      setValue(tc.toHex());
    }
    onColorChange("#" + hex);
  }

  function onHueChange(hue: any) {
    const tc = tiny(hue);
    setHsl(hue);
    setHsv(tc.toHsv());
    setValue(tc.toHex());
    onColorChange("#" + tc.toHex());
    
    let hueColor = tiny({h: hue.h, s: 1, v: 1});
    setHueAsHex(hueColor.toHex());
  }

  function onInputChange(color: any) {
    const hex = color.charAt(0) === '#' ? color.substring(1) : color;
    const tc = tiny(hex);
    setHsl(tc.toHsl());
    setHsv(tc.toHsv());
    setValue(tc.toHex());
    onColorChange("#" + hex);

    let hueColor = tiny({h: tc.toHsl().h, s: 1, v: 1});
    setHueAsHex(hueColor.toHex());
  }

  const SaturationPointer = () => {
    let styles = {...basePointerStyles, 
      transform: "translate(-8px, -8px)",
      backgroundColor: `#${value}`
    }
    return (
      <div className={"hue-sat-pointer"} style={styles} />
    )
  }
  const HuePointer = () => {
    let styles = {...basePointerStyles,
      transform: "translate(-8px, -1px)",
      backgroundColor: `#${hueAsHex}`
    }
    return (
      <div className={"hue-sat-pointer"} style={styles} />
    )
  }

  return (
    <div className={"color-picker"}>
      <div className={"saturation-block"}>
        <Saturation 
          onChange={onSaturationChange} 
          hsl={hsl} 
          hsv={hsv}
          pointer={SaturationPointer} />
      </div>
      <div className={"hue-block"}>
        <Hue 
          onChange={onHueChange} 
          hsl={hsl}
          pointer={HuePointer} />
      </div>
      <div className={"npt"}>
        <div className={"swatch"} style={{backgroundColor: `#${value}`}}></div>
        <EditableInput 
            value={'#' + value}
            onChange={onInputChange}
            style={inputStyles}
        />
      </div>
    </div>
  );
}
